/**
 * let image = new Image()
 * image.crossOrigin = '*' // 支持跨域图片
 * image.src = elem.src
 * @param {img} img 传入img对象
 */
// 方法一将图片转换为Base64
function image2Base64(img) {
	let canvas = document.createElement('canvas')
	canvas.width = img.width
	canvas.height = img.height
	let ctx = canvas.getContext('2d')
	ctx.drawImage(img, 0, 0, canvas.width, canvas.height)
	let dataURL = canvas.toDataURL('image/png') // 可选其他值 image/jpeg
	return dataURL
}
//方法二：Blob和FileReader 对象
function imageUrl2Base64(imgUrl) {
	return new Promise((reslove,reject)=>{
		window.URL = window.URL || window.webkitURL;
		var xhr = new XMLHttpRequest();
		xhr.open("get", imgUrl, true);
		// 至关重要
		xhr.responseType = "blob";
		xhr.onload = function() {
			if (this.status == 200) {
				//得到一个blob对象
				var blob = this.response;
				console.log("blob", blob)
				// 至关重要
				let oFileReader = new FileReader();
				oFileReader.onloadend = function(e) {
					let base64 = e.target.result;
					reslove(base64)
				};
				oFileReader.readAsDataURL(blob);
			}
		}
		xhr.send();
	})
	
}
export default {
	image2Base64,
	imageUrl2Base64
}



// WEBPACK FOOTER //
// ./static/js/function/image2Base64.js